// Detect whether the site is running inside the Android app (TWA) rather than
// a regular browser tab. Used to hide the "download the app" call-to-action
// when the user is already in the app.
//
// Two signals, either is sufficient:
//  1) The TWA launches the site with document.referrer = "android-app://<pkg>/..."
//  2) The PWA is running in standalone display mode (also true for an installed
//     PWA, which is fine — no point offering an APK download there either).

const TWA_PACKAGE = 'net.labanane.twa'

export function isInApp() {
  try {
    if (document.referrer && document.referrer.startsWith('android-app://')) {
      return true
    }
    // Standalone display => installed PWA or TWA; hide the download prompt.
    const standalone =
      window.matchMedia && window.matchMedia('(display-mode: standalone)').matches
    // iOS Safari legacy flag
    const iosStandalone = window.navigator.standalone === true
    return Boolean(standalone || iosStandalone)
  } catch (e) {
    return false
  }
}

// Specifically the Android TWA (referrer carries our package id).
export function isAndroidApp() {
  try {
    return (
      typeof document.referrer === 'string' &&
      document.referrer.startsWith(`android-app://${TWA_PACKAGE}`)
    )
  } catch (e) {
    return false
  }
}

// URL of the downloadable APK, served from the site itself.
export const APK_URL = '/labanane.apk'
